import { IApplicationState } from '../../types/redux';

export const selectActiveFeature = (state: IApplicationState) => {
  return state.activeFeature;
};
